import { createAction, props } from '@ngrx/store';
import { Signin } from 'src/app/signin.interface';

export const loadHeaders = createAction(
  '[Header] Load Headers'
);

export const loadHeadersSuccess = createAction(
  '[Header] Load Headers Success',
  props<{ data: any }>()
);

export const loadHeadersFailure = createAction(
  '[Header] Load Headers Failure',
  props<{ error: any }>()
);

export const loadConfirmModal = createAction(
  '[Header] Load Confirm Modal'
);

export const closeConfirmModal = createAction(
  '[Header] Close Confirm Modal'
);

export const agreeConfirmModal = createAction(
  '[Header] Confirm Login',
  props< {data: {Token: string; UUID: string; }}>()
);

export const confirmSuccessful = createAction(
  '[Backend API] Confirm New User Successful',
  props<{ data: Signin}>()
);

export const confirmNotSuccessful = createAction(
  '[Backend API] Confirm New User Not Successful'
);

export const signOut = createAction(
  '[Header / Sidebar] Signout'
);

export const signOutSuccessful = createAction(
  '[Game360 API] Signout Successful',
  props<{ data: string}>()
);

export const signOutFailed = createAction(
  '[Game360 API] Signout Failed'
);
